module.exports = __webpack_public_path__ + "static/media/ArrowsAlt.30a185d4.svg";